import React from 'react';

/*
    - ihoDesignSystem
*/
import { Alert, Box, Button, Checkbox, Grid, Image, Typography } from '@iho-design-system/Loader';

/*
    - icon
*/
import EmptySVG from '../../../assets/images/icons/empty.svg';
import LoadingCustomSVG from '../../../assets/images/icons/loading-custom.svg';
import PaginationLeftSVG from '../../../assets/images/icons/pagination-left.svg';
import PaginationRightSVG from '../../../assets/images/icons/pagination-right.svg';
import TrashBinSVG from '../../../assets/images/icons/trashbin-white.svg';

/*
    - api
*/
import post from '../../../api/post';

const List = ({ props, alertProps, reloadUserProps, paginationProps }) => {

    /*
       - defaultData
    */
    const [agentsResult, setAgentsResult] = React.useState('loading');
    const [selectedAgent, setSelectedAgent] = React.useState({});

    React.useEffect(() => {
        if (props.agents !== '') {
            if (props.agents.status === 200 && props.agents.data.Data.length > 0) {
                setAgentsResult(props.agents.data);
            } else {
                setAgentsResult('empty');
            }
        }
    }, [props]);

    /*
        - selectedAgentHandler
    */
    const selectedAgentHandler = (obj, status) => {
        setSelectedAgent(prev => ({ ...prev, [obj.Id]: status }));
    }

    React.useEffect(() => {
        let keys = Object.keys(selectedAgent);
        keys.forEach((obj) => {
            if (selectedAgent[obj] === true) {
                document.querySelector(`.list${obj}`).style.backgroundColor = 'var(--blue-ultra-light)';
            } else {
                document.querySelector(`.list${obj}`).style.backgroundColor = 'var(--white)';
            }
        });
    }, [selectedAgent]);

    /*
        - removeAgent
    */
    const removeAgent = async () => {
        let keys = Object.keys(selectedAgent);
        let selectedAgentId = [];
        keys.forEach((obj) => {
            if (selectedAgent[obj] === true) {
                selectedAgentId.push(obj)
            }
        });
        if (selectedAgentId.length === 0) {
            alertProps(['danger', ' نماینده‌ای انتخاب نشده است']);
            return false;
        }
        let parameters = {
            ctrl: 'UserAgents',
            method: 'RemoveAgents',
            query: '',
            body: selectedAgentId
        };
        let result = await post(parameters);
        if (result.status === 200) {
            alertProps(['success', 'با موفقیت انجام شد']);
            reloadUserProps(Math.floor(Math.random() * 100));
            setSelectedAgent({});
        } else {
            alertProps(['danger', result.data.Message]);
        }
        document.querySelectorAll('input[type=checkbox]').forEach((obj) => {
            obj.checked = false;
        });
    }

    if (agentsResult === 'loading') {
        return (
            <Image
                className={`d-block mx-auto`}
                src={LoadingCustomSVG}
                ms={{
                    width: '40px',
                    height: '40px'
                }} />
        );
    }

    if (agentsResult === 'empty') {
        return (
            <React.Fragment>
                <Box>
                    <Image
                        className={`mx-auto`}
                        src={EmptySVG}
                        ms={{
                            display: 'block',
                            width: '120px',
                            height: '120px'
                        }} />
                    <Typography
                        className={`d-block text-center`}
                        component='h2'>
                        لیست نمایندگان شما خالی است :(
                    </Typography>
                    <Box
                        className={`my-md`} />
                    <Typography
                        className={`d-block text-center`}
                        component='strong'>
                        تاکنون هیچ نماینده‌ای را ثبت نکرده اید!  
                    </Typography>
                </Box>
            </React.Fragment>
        );
    }

    if (agentsResult !== 'empty') {
        return (
            <React.Fragment>
                <Grid>
                    <Grid.Wrapper>
                        <Grid.Item
                            size='col-12'>
                            <Alert
                                className={`position-static no-shadow`}
                                color='danger'>
                                    نماینده می تواند از امکانات مالی حساب کاربری شما مانند کیف پول، اعتبار و ... استفاده کند.
                            </Alert>
                        </Grid.Item>
                        <Grid.Item
                            size='col-12'>
                            <Box
                                ms={{
                                    '@media(max-width:992px)': {
                                        overflowX: 'scroll'
                                    }
                                }}>
                                <Box
                                    ms={{
                                        minWidth: '992px'
                                    }}>
                                    <Box
                                        className={`d-inline-block w-100 my-sm mt-0 px-xl py-lg rounded-sm`}
                                        ms={{
                                            backgroundColor: 'var(--gray-light)'
                                        }}>
                                        <Box
                                            className={`d-inline-block w-25`}>
                                            <Typography>
                                                نام و نام خانوادگی
                                            </Typography>
                                        </Box>
                                        <Box
                                            className={`d-inline-block w-25`}>
                                            <Typography>
                                                نام شرکت
                                            </Typography>
                                        </Box>
                                        <Box
                                            className={`d-inline-block w-25`}>
                                            <Typography>
                                                شماره موبایل
                                            </Typography>
                                        </Box>
                                        <Box
                                            className={`d-inline-block w-25`}>
                                            <Typography>
                                                ایمیل
                                            </Typography>
                                        </Box>
                                    </Box>
                                    <Box
                                        className={`border-solid border-light rounded-sm`}
                                        ms={{
                                            backgroundColor: 'var(--white)'
                                        }}>
                                        {agentsResult.Data.map((obj, index) => {
                                            return (
                                                <Box
                                                    key={index}>
                                                    <Box
                                                        className={`list${obj.Id} d-flex justify-content-between px-lg py-md border-solid-bottom border-light`}>
                                                        <Box
                                                            className={`w-25`}>
                                                            <Checkbox
                                                                onChange={(status) => selectedAgentHandler(obj, status)}
                                                                label={obj.FullName}
                                                                ms={{
                                                                    verticalAlign: 'middle'
                                                                }} />
                                                        </Box>
                                                        <Box
                                                            className={`w-25`}>
                                                            {obj.OrgnizationName}
                                                        </Box>
                                                        <Box
                                                            className={`w-25`}>
                                                            {obj.MobileNumber}
                                                        </Box>
                                                        <Box
                                                            className={`w-25`}>
                                                            {obj.Email}
                                                        </Box>
                                                    </Box>
                                                </Box>
                                            );
                                        })}
                                        <Box
                                            className={`d-flex justify-content-center rounded-sm rounded-top-right-0 rounded-top-left-0`}
                                            ms={{
                                                height: '56px',
                                                backgroundColor: 'var(--gray-ultra-light)'
                                            }}>
                                            <Box
                                                className={`d-flex align-self-center`}
                                                ms={{
                                                    width: '33.3333%',
                                                    gap: 'var(--sizing-sm)'
                                                }}>
                                                <Button
                                                    onClick={() => removeAgent()}
                                                    className={`d-flex align-item-center`}
                                                    color='danger'>
                                                    <Image
                                                        src={TrashBinSVG} />
                                                    حذف
                                                </Button>
                                            </Box>
                                            <Box
                                                className={`d-flex justify-content-center align-item-center`}
                                                ms={{
                                                    width: '33.3333%',
                                                    gap: '16px'
                                                }}>
                                                <Button
                                                    onClick={() => paginationProps(-1)}
                                                    className={`p-0 rounded-lg`}
                                                    variant='outlined'
                                                    color='primary'
                                                    ms={{
                                                        width: '30px !important',
                                                        height: '30px !important',
                                                        backgroundColor: 'var(--white) !important',
                                                        borderColor: 'var(--white) !important',
                                                        boxShadow: 'var(--shadow-dark)'
                                                    }}>
                                                    <Image
                                                        src={PaginationRightSVG} />
                                                </Button>
                                                <Typography
                                                    className={`text-primary`}>
                                                    {agentsResult.PageIndex} / {Math.ceil(agentsResult.TotalItems / agentsResult.PageSize)}
                                                </Typography>
                                                <Button
                                                    onClick={() => paginationProps(1)}
                                                    className={`p-0 rounded-lg`}
                                                    variant='outlined'
                                                    color='primary'
                                                    ms={{
                                                        width: '30px !important',
                                                        height: '30px !important',
                                                        backgroundColor: 'var(--white) !important',
                                                        borderColor: 'var(--white) !important',
                                                        boxShadow: 'var(--shadow-dark)'
                                                    }}>
                                                    <Image
                                                        src={PaginationLeftSVG} />
                                                </Button>
                                            </Box>
                                            <Box
                                                ms={{
                                                    width: '33.3333%'
                                                }} />
                                        </Box>
                                    </Box>
                                </Box>
                            </Box>
                        </Grid.Item>
                    </Grid.Wrapper>
                </Grid>
            </React.Fragment >
        );
    }

}

export default List;